import { render, staticRenderFns } from "./companyBeenReg.vue?vue&type=template&id=584e9b48&scoped=true&"
import script from "./companyBeenReg.vue?vue&type=script&lang=js&"
export * from "./companyBeenReg.vue?vue&type=script&lang=js&"
import style0 from "./companyBeenReg.vue?vue&type=style&index=0&id=584e9b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e9b48",
  null
  
)

export default component.exports